module.exports = __webpack_public_path__ + "static/img/01038B_3_4_C_20230525_LC.24714aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_3_4_C_20230525_LC.png
// module id = 6x+r
// module chunks = 0